// extracted by mini-css-extract-plugin
export const answer = "CreditLinkageQuestions__answer__luxHF";
export const answers = "CreditLinkageQuestions__answers__QNjf4";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const creditLinkageQuestions = "CreditLinkageQuestions__creditLinkageQuestions__TsZYs";
export const creditQuestion = "CreditLinkageQuestions__creditQuestion__Mo1G+";
export const dot = "CreditLinkageQuestions__dot__+zZJ6";
export const dotActive = "CreditLinkageQuestions__dotActive__553iw";
export const dotsPager = "CreditLinkageQuestions__dotsPager__m0bIj";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const questionTitle = "CreditLinkageQuestions__questionTitle__j4VTM";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const textCenter = "CreditLinkageQuestions__textCenter__7g2tR";